import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const achievements = [
  {
    image: "/achievements/7.jpeg",
    title: "Conducted a Career Guidance Program for 12th std students in the title 'Pursuing Engineering as your Future career'",
    place: "Sri Matha Matric.Hr.Sec.School,Kumbakonam - Oct-2024",
  },
  {
    image: "/achievements/5.jpeg",
    title: "Participated in Technical Paper Presentation in 'Quantum in Financial Security'",
    place: "Sri Eshwar College of Engineering - Feb-2025",
  },
  {
    image: "/achievements/1.jpg",
    title: "1st Prize in RJ contest",
    place: "Sri Eshwar College of Engineering - Feb-2025",
  },
  {
    image: "/achievements/2.jpg",
    title: "3rd Prize in Tamil Elocution",
    place: "Sri Eshwar College of Engineering - Feb-2025",
  },
  {
    image: "/achievements/3.jpg",
    title: "2nd Prize in Technical Paper Presentation on Quantum Computing ",
    place: "PSG College of Technology - Mar-2025",
  },
  {
    image: "/achievements/4.jpeg",
    title: "2nd Prize in English Declamation",
    place: "Sri Eshwar College of Engineering - Feb-2026",
  },
  {
    image: "/achievements/6.jpeg",
    title: "A 30 days Marketing intern at Kumbakonam  ",
    place: "Vebbox Software Solutions,Kumbakonam - May-2025",
  },
];

export default function Achievements() {
  const containerRef = useRef(null);

  /* 👉 Scroll by one card */
  const scroll = (direction) => {
    const el = containerRef.current;
    if (!el) return;

    const cardWidth = 340; // card width + gap
    el.scrollBy({
      left: direction === "left" ? -cardWidth : cardWidth,
      behavior: "smooth",
    });
  };

  return (
    <section id="achievements" className="max-w-5xl mx-auto px-6 pt-10 pb-20">
      {/* Heading */}
      <h2 className="text-2xl font-bold text-black dark:text-white mb-8">
        Progress & Experiences
      </h2>

      {/* Wrapper */}
      <div className="relative">
        {/* LEFT ARROW */}
        <button
          onClick={() => scroll("left")}
          className="
            absolute -left-4 top-1/2 -translate-y-1/2 z-10
            p-2 rounded-full
            bg-white/80 dark:bg-black/60
            backdrop-blur-md
            border border-black/10 dark:border-white/20
            shadow-md hover:scale-110 transition
          "
        >
          <ChevronLeft size={20} />
        </button>

        {/* RIGHT ARROW */}
        <button
          onClick={() => scroll("right")}
          className="
            absolute -right-4 top-1/2 -translate-y-1/2 z-10
            p-2 rounded-full
            bg-white/80 dark:bg-black/60
            backdrop-blur-md
            border border-black/10 dark:border-white/20
            shadow-md hover:scale-110 transition
          "
        >
          <ChevronRight size={20} />
        </button>

        {/* Cards Row */}
        <div
          ref={containerRef}
          className="
            flex gap-8 overflow-hidden
            scroll-smooth
          "
        >
          {achievements.map((item, i) => (
            <div
              key={i}
              className="
                relative min-w-[320px] h-[220px]
                rounded-2xl overflow-hidden
                border border-black/10 dark:border-white/15
                bg-white/40 dark:bg-white/5
                backdrop-blur-xl shadow-lg
                group
                transition-all duration-500
                hover:-translate-y-2 hover:shadow-2xl
              "
            >
              {/* Image */}
              <img
                src={item.image}
                alt={item.title}
                className="
                  w-full h-full object-cover
                  transition-transform duration-700
                  group-hover:scale-110
                "
              />

              {/* Hover overlay */}
              <div
                className="
                  absolute inset-0
                  bg-black/70 backdrop-blur-sm
                  opacity-0 group-hover:opacity-100
                  transition duration-300
                  flex flex-col justify-end
                  p-4
                "
              >
                <p className="text-white font-semibold text-sm">
                  {item.title}
                </p>
                <p className="text-white/70 text-xs mt-1">
                  {item.place}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
